/**
 * ReservationFlag — availability dot used in the vehicles list and the detail
 * narrow rail. Green ✓ when the car is free to sell, warn × when it carries a
 * reservation. Shared so the rail mirrors the list's primary signal exactly.
 */

import type { Vehicle } from './api';

export function ReservationFlag({
  vehicle,
  className = '',
}: {
  vehicle: Pick<Vehicle, 'rezervace'>;
  className?: string;
}) {
  const available = !vehicle.rezervace || vehicle.rezervace.length === 0;
  const title = available ? 'K dispozici' : `Rezervované: ${vehicle.rezervace}`;
  return (
    <span
      title={title}
      aria-label={title}
      role="img"
      className={
        'relative grid size-3.5 place-items-center rounded-full border-[1.5px] ' +
        (available ? 'border-ok bg-ok text-paper' : 'border-warn text-warn') +
        (className ? ' ' + className : '')
      }
    >
      <span className="text-[9px] font-bold leading-none">{available ? '✓' : '×'}</span>
    </span>
  );
}
